<template>
  <span class="bg-green-2 h-3 w-3 rounded-full"></span>
</template>
